import Vue from "vue";
const SocketEventCenter = new Vue({
  methods: {
    emit(func_name, data) {
      this.$emit(func_name, data);
    },
    on(func_name, callback) {
      this.$on(func_name, callback);
    },
    off(func_name, callback) {
      if (this._events[func_name]) {
        // 检查是否已注册该事件
        this.$off(func_name, callback);
      } else {
        // console.warn(`${func_name} 事件监听未注册过`);
      }
    }
  }
});
export default SocketEventCenter;